import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';

export class QuickRouter extends Component {
    // MUST be inside a <route> element.

    constructor(props) {
        super(props);
        this.state = { route: null };
    }

    componentDidMount() {
        window.addEventListener('quick-router-event', this.quickRouterEvent);
    }

    componentWillUnmount() {
        window.removeEventListener('quick-router-event', this.quickRouterEvent);
    }

    quickRouterEvent = (e) => {
        this.setRoute(e.detail);
    };

    setRoute = (route) => {
        this.setState({ route: route });
    };

    render() {
        if (this.state.route) {
            return <Navigate to={this.state.route}/>;
        }
        return <></>;
    }
}